var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import React from "react";
const YoutubeIcon = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ xmlns: "http://www.w3.org/2000/svg", width: "19", height: "19", viewBox: "0 0 19 19" }, props), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    d: "M9.783 3.126c1.117.006 5.217.049 6.359.357.731.196 1.307.776 1.503 1.512C18 6.33 18 9.114 18 9.114s0 2.784-.355 4.118c-.196.736-.772 1.316-1.503 1.513-1.215.327-5.784.355-6.537.357h-.21c-.753-.002-5.322-.03-6.537-.357-.731-.197-1.307-.777-1.503-1.513-.317-1.191-.35-3.538-.355-4.028v-.181c.004-.49.038-2.836.355-4.028.196-.736.772-1.316 1.503-1.512C4 3.175 8.1 3.132 9.218 3.126zM7.76 6.586v5.055l4.444-2.527L7.76 6.586z"
  }
));
var YoutubeIcon_default = YoutubeIcon;
export {
  YoutubeIcon_default as default
};
//# sourceMappingURL=YoutubeIcon.js.map
